import { render, staticRenderFns } from "./wing-blank.vue?vue&type=template&id=57864c5c&scoped=true"
import script from "./wing-blank.vue?vue&type=script&lang=js"
export * from "./wing-blank.vue?vue&type=script&lang=js"
import style0 from "./wing-blank.vue?vue&type=style&index=0&id=57864c5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57864c5c",
  null
  
)

export default component.exports